import request from '@/utils/request'

//获取询比信息
export function getEnquiryList(params) {
    return request({
        url: '/home/list',
        method: 'get',
        params
    })
}
//获取采购公告列表
export function getPurchaseList(params) {
    return request({
        url: '/home/purchaseNoticeList',
        method: 'get',
        params
    })
}
//获取中标公告列表
export function getNoticeList(params) {
    return request({
        url: '/home/winNoticeList',
        method: 'get',
        params
    })
}
//获取废标公告列表
export function getRNoticeList(params) {
    return request({
        url: '/home/failNoticeList',
        method: 'get',
        params
    })
}

//获取采购公告详情
export function getPurchase(id) {
    return request({
        url: '/home/purchaseNoticeInfo/' + id,
        method: 'get',
    })
}
//获取采购公告详情
export function getEnquiry(id) {
    return request({
        url: '/home/' + id,
        method: 'get',
    })
}

//获取中标公告详情
export function getNotice(id) {
    return request({
        url: '/home/winNoticeInfo/' + id,
        method: 'get',
    })
}

//获取废标公告详情
export function getRNotice(id) {
    return request({
        url: '/home/failNoticeInfo/' + id,
        method: 'get',
    })
}

//获取供应商列表
export function getSupplierList(params) {
    return request({
        url: '/home/supplierList',
        method: 'get',
        params,
    })
}

//获取变更公告列表
export function getChangeList(params) {
    return request({
        url: '/home/proChangeNoticeList',
        method: 'get',
        params
    })
}

//获取变更公告详情
export function getCNotice(id) {
    return request({
        url: '/home/proChangeNoticeInfo/' + id,
        method: 'get',
    })
}

//获取中止公告列表
export function getSuspendList(params) {
    return request({
        url: '/home/suspendNoticeList',
        method: 'get',
        params
    })
}

//获取中止公告详情
export function getSNotice(id) {
    return request({
        url: '/home/suspendNoticeInfo/' + id,
        method: 'get',
    })
}
//获取配置信息
export function getConfig() {
    return request({
        url: '/system/config/configKey/getHomeJump',
        method: 'get',
    })
}
export function login(username, password, code, uuid, token) {
    const data = {
        username,
        password,
        code,
        uuid,
        token,
    };
    return request({
        url: "/login",
        headers: {
            isToken: false,
            repeatSubmit: false,
        },
        method: "post",
        data: data,
    });
}
// 获取用户详细信息
export function getInfo() {
    return request({
        url: "/getInfo",
        method: "get",
    });
}
// 获取用户详细信息
export function getLoginSetting() {
    return request({
        url: "/system/config/configKey/getHomeLogin",
        method: "get",
    });
}
export function getRegisterSetting() {
    return request({
        url: "/system/config/configKey/getHomeSupplierRegister",
        method: "get",
    });
}
// 获取验证码
export function getCodeImg() {
    return request({
        url: "/captchaImage",
        headers: {
            isToken: false,
        },
        method: "get",
        timeout: 20000,
    });
}